import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  LOAD_PROVIDER_LIST,
  CREATE_PROVIDER,
  EDIT_PROVIDER_BY_ID,
  LOAD_PROVIDER_BY_ID,
  DELETE_PROVIDER,
} from './actions';
import { PROVIDER_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin,
  createOperationStateReducer,
  updateLoadParameterReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  providerListMeta: {},
  loadingProviderList: false,
  providerList: [],
  loadingCurrentProvider: false,
  currentProvider: {},
  loadingCreateProvider: false,
  loadingEditProviderById: false,
  loadingDeleteProvider: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(PROVIDER_MODULE + LOAD_PROVIDER_LIST, 'providerList', 'loadingProviderList'),
  ...updateLoadParameterReducer(PROVIDER_MODULE + LOAD_PROVIDER_BY_ID, 'currentProvider', 'loadingCurrentProvider', {}),
  ...createOperationStateReducer(PROVIDER_MODULE + CREATE_PROVIDER, 'loadingCreateProvider'),
  ...createOperationStateReducer(PROVIDER_MODULE + EDIT_PROVIDER_BY_ID, 'loadingEditProviderById'),
  ...createOperationStateReducer(PROVIDER_MODULE + DELETE_PROVIDER, 'loadingDeleteProvider'),
}, initialState);

export default reducer;

export const getProviderData = createSelector(
  [state => state[PROVIDER_MODULE]],
  state => {
    const {
      providerListMeta,
      loadingProviderList,
      providerList,
      loadingCurrentProvider,
      currentProvider,
      loadingCreateProvider,
      loadingEditProviderById,
      loadingDeleteProvider,
    } = state;
    return {
      providerListMeta,
      loadingProviderList,
      providerList,
      loadingCurrentProvider,
      currentProvider,
      loadingCreateProvider,
      loadingEditProviderById,
      loadingDeleteProvider,
    };
  },
);
